import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import usePDPKeySellingPoints from 'data-hooks/usePDPKeySellingPoints';
import Placeholder from 'components/consumer/Placeholder';
import StandardModal from 'components/consumer/StandardModal';
import IconReturns from 'components/icons/iconReturns';
import IconMaterialsDesigned from 'components/icons/iconMaterialsDesigned';
import IconCalendar from 'components/icons/iconCalendar';
import IconDeliveryFlat from 'components/icons/iconDeliveryFlat';
import IconClock from 'components/icons/IconClock';
import iconPremiumDelivery from 'components/icons/iconPremiumDelivery';
import IconAffirmLogo from 'components/icons/iconAffirmLogo';
import PDPValuePropsModalV2 from './PDPValuePropsModalV2';
const ICON_MAP = {
  IconReturns,
  IconMaterialsDesigned,
  IconCalendar,
  IconDeliveryFlat,
  IconClock,
  iconPremiumDelivery,
  IconAffirmLogo
};
const PDPKeySellingPointsV2 = t0 => {
  const $ = _c(28);
  const {
    mobileCarousel: t1
  } = t0;
  const mobileCarousel = t1 === undefined ? false : t1;
  const {
    loading,
    data
  } = usePDPKeySellingPoints();
  const [activePanel, setActivePanel] = useState(null);
  const listRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = direction => {
      const list = listRef.current;
      if (!list) {
        return;
      }
      list.scrollBy({
        left: direction * list.clientWidth,
        behavior: "smooth"
      });
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const scrollByOne = t2;
  if (loading) {
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex flex-col justify-center mt-8 p-0 w-full"><ul className="items-center flex justify-center list-none m-0 p-0">{[0, 1, 2].map(_temp)}</ul></div>;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  if (!data || data.length === 0) {
    return null;
  }
  const t3 = !mobileCarousel;
  let t4;
  if ($[2] !== mobileCarousel || $[3] !== t3) {
    t4 = classNames("flex justify-center mt-8 p-0 w-full", {
      "flex-col": t3,
      "flex-row items-center": mobileCarousel
    });
    $[2] = mobileCarousel;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== mobileCarousel) {
    t5 = mobileCarousel && <button type="button" aria-label="Previous" className="lg:hidden bg-transparent border-0 px-3 text-2xl text-gray-light2 cursor-pointer" onClick={() => scrollByOne(-1)}>‹</button>;
    $[5] = mobileCarousel;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = !mobileCarousel;
  let t7;
  if ($[7] !== mobileCarousel || $[8] !== t6) {
    t7 = classNames("items-center flex list-none m-0 p-0", {
      "justify-center": t6,
      "flex-1 max-[1023px]:overflow-x-auto max-[1023px]:snap-x max-[1023px]:snap-mandatory max-[1023px]:[scrollbar-width:none] lg:justify-center": mobileCarousel
    });
    $[7] = mobileCarousel;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== data || $[11] !== mobileCarousel) {
    let t9;
    if ($[13] !== mobileCarousel) {
      t9 = (item, index) => {
        const iconData = item.icon;
        const IconComponent = ICON_MAP[iconData.name];
        return IconComponent ? <li className={classNames("items-center flex flex-col justify-center list-none m-0 p-0", {
          "max-[1023px]:min-w-full max-[1023px]:snap-center": mobileCarousel
        })} key={`ksp-${item.id || index}`}><button type="button" className="text-xs bg-transparent border-2 border-solid border-transparent cursor-pointer text-gray-light1 items-center flex flex-col px-2 py-0.5 m-0 text-center max-w-[33vw] !normal-case max-[767px]:flex-1 max-[767px]:leading-[unset] max-[767px]:p-0 max-[767px]:m-0 ml-5 last:mr-5 focus:text-brand hover:text-brand" onClick={() => setActivePanel(item)}><div className="flex items-center justify-center mb-2"><IconComponent aria-hidden="true" color="currentColor" height={iconData.height || 26} width={iconData.width || 26} /></div><span className="max-[767px]:max-w-[90px]">{item.label}</span></button></li> : null;
      };
      $[13] = mobileCarousel;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    t8 = data.map(t9);
    $[10] = data;
    $[11] = mobileCarousel;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <ul ref={listRef} className={t7}>{t8}</ul>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== mobileCarousel) {
    t10 = mobileCarousel && <button type="button" aria-label="Next" className="lg:hidden bg-transparent border-0 px-3 text-2xl text-gray-light2 cursor-pointer" onClick={() => scrollByOne(1)}>›</button>;
    $[18] = mobileCarousel;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== activePanel) {
    t11 = activePanel && <StandardModal isOpen={true} title={activePanel.label} icon={(() => {
      const Icon = ICON_MAP[activePanel.icon?.name];
      return Icon ? <div className="[&_g]:stroke-[#fff]"><Icon width={25} height={30} color="#ffffff" /></div> : null;
    })()} onClose={() => {
      setActivePanel(null);
    }}><PDPValuePropsModalV2 description={activePanel.description} /></StandardModal>;
    $[20] = activePanel;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t4 || $[25] !== t5 || $[26] !== t9) {
    t12 = <div className={t4}>{t5}{t9}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t4;
    $[25] = t5;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
PDPKeySellingPointsV2.propTypes = {
  mobileCarousel: PropTypes.bool
};
export default PDPKeySellingPointsV2;
function _temp(idx) {
  return <li className="items-center flex flex-col justify-center list-none m-0 p-0" key={`PDPKeySellingPointsV2__item${idx}`}><div className="text-xs bg-transparent border-2 border-solid border-transparent cursor-pointer text-gray-light1 items-center flex flex-col px-2 py-0.5 m-0 text-center max-w-[33vw] !normal-case max-[767px]:flex-1 max-[767px]:leading-[unset] max-[767px]:p-0 max-[767px]:m-0 ml-5 last:mr-5 focus:text-brand hover:text-brand [&_span]:max-[767px]:max-w-[90px]"><div className="flex items-center justify-center mb-2"><Placeholder type="round" loading={true} style={{
          height: 36,
          width: 36
        }} /></div><span className="max-[767px]:max-w-[90px]"><Placeholder type="rect" loading={true} style={{
          height: 12,
          width: 120
        }} /></span></div></li>;
}